import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-95db046a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tp-tile-blur" }
const _hoisted_2 = {
  width: "80",
  height: "66",
  viewBox: "0 0 80 66",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_3 = { filter: "url(#filter0_f2)" }
const _hoisted_4 = ["fill"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("filter", {
    id: "filter0_f2",
    x: "-1",
    y: "0",
    width: "83",
    height: "66",
    filterUnits: "userSpaceOnUse",
    "color-interpolation-filters": "sRGB"
  }, [
    /*#__PURE__*/_createElementVNode("feFlood", {
      "flood-opacity": "0",
      result: "BackgroundImageFix"
    }),
    /*#__PURE__*/_createElementVNode("feBlend", {
      mode: "normal",
      in: "SourceGraphic",
      in2: "BackgroundImageFix",
      result: "shape"
    }),
    /*#__PURE__*/_createElementVNode("feGaussianBlur", {
      stdDeviation: "12.5",
      result: "effect1_foregroundBlur"
    })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", _hoisted_2, [
      _createElementVNode("g", _hoisted_3, [
        _createElementVNode("path", {
          d: "M57 33C57 37.4183 49.6127 41 40.5 41C31.3873 41 24 37.4183 24 33C24 28.5817 31.3873 25 40.5 25C49.6127 25 57 28.5817 57 33Z",
          fill: $props.color
        }, null, 8, _hoisted_4)
      ]),
      _hoisted_5
    ]))
  ]))
}